import { render, staticRenderFns } from "./EditPreferencesAction.vue?vue&type=template&id=1a871be5&scoped=true&"
import script from "./EditPreferencesAction.vue?vue&type=script&lang=js&"
export * from "./EditPreferencesAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a871be5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
